export default __webpack_public_path__ + "static/media/mule-deer@3x.d879782d.jpg";